<template>
  <v-container class="fill-height">
    <v-row justify="center">
      <v-col cols="12" md="6" sm="8">
        <v-card color="error" elevation="4">
          <v-card-title>
            <v-icon size="48"> mdi-cancel</v-icon>
            {{ $t("app.403.title") }}
          </v-card-title>
          <v-card-text>
            <b>
              {{ $t("app.403.subtitle") }}
            </b>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$router.go(-1)">
              {{ $t("app.back") }}
            </v-btn>
            <v-btn color="secondary" :to="{ name: 'home' }">{{ $t("app.backHome") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Forbidden extends Vue {}
</script>

<style scoped></style>
